<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        class="close-button"
        (click)="onDismissIntegrationInputModal()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-item class="transparent-bg" button="false">
    <img
      class="zapier-logo"
      src="{{ integration.imageSrc }}"
      slot="start"
      style="
        border-radius: 10px;
        max-width: 180px;
        background: white;
        margin-right: 15px;
      "
    />
    <ion-label text-wrap>
      <h3 style="font-weight: 700; font-size: 1.3rem">
        {{ integration.name }}
      </h3>
      <div [innerHTML]="integration.preview"></div>
      <p *ngIf="integration.documentation">
        <a [href]="integration.documentation" target="_blank">
          Documentation <ion-icon name="open-outline"></ion-icon>
        </a>
      </p>
    </ion-label>
  </ion-item>
</ion-header>
<ion-content>
  <form
    #integrationForm="ngForm"
    (ngSubmit)="onSubmitIntegrationInputModal()"
    novalidate
  >
    <div style="padding: 5px">
      <ng-container *ngFor="let inputField of integration.userInput">
        <ion-card
          class="outline-card"
          *ngIf="
            !inputField.hide || !inputField.hide(integrationSettings.userInput)
          "
        >
          <ion-list>
            <ion-item *ngIf="inputField.type !== 'fieldMapping'">
              <ion-checkbox
                *ngIf="inputField.type === 'checkbox'"
                [(ngModel)]="integrationSettings.userInput[inputField.key]"
                [name]="inputField.key"
                slot="start"
              ></ion-checkbox>
              <ion-label
                *ngIf="inputField.type === 'checkbox'"
                text-wrap
                style="font-size: 0.65rem"
              >
                {{ inputField.label }}
              </ion-label>
              <ion-label
                *ngIf="inputField.type !== 'checkbox'"
                position="stacked"
                text-wrap
              >
                {{ inputField.label }}
                <span *ngIf="inputField.required" style="color: red">*</span>
              </ion-label>
              <ion-input
                *ngIf="
                  inputField.type === 'text' ||
                  inputField.type === 'secret' ||
                  !inputField.type
                "
                [type]="inputField.type === 'secret' ? 'password' : 'text'"
                [required]="inputField.required ?? false"
                [(ngModel)]="integrationSettings.userInput[inputField.key]"
                [name]="inputField.key"
                [placeholder]="inputField.placeholder ?? 'Enter text here...'"
                style="margin-top: 20px"
                #inputRef="ngModel"
              ></ion-input>
              <ion-select
                *ngIf="inputField.type === 'dropdown'"
                [(ngModel)]="integrationSettings.userInput[inputField.key]"
                [name]="inputField.key"
                interface="popover"
                [required]="inputField.required ?? false"
                #inputRef="ngModel"
              >
                <ion-select-option
                  [value]="option.value"
                  *ngFor="let option of inputField.options"
                  >{{ option.label }}</ion-select-option
                >
              </ion-select>
              <div
                *ngIf="inputField.type === 'emoji'"
                style="margin-top: 20px"
                (click)="openEmojiPicker(inputField, $event)"
                aria-label="Selected emoji. Click to change."
                class="emoji-picker-container"
              >
                <!-- Hidden input for form binding -->
                <input
                  type="hidden"
                  [(ngModel)]="integrationSettings.userInput[inputField.key]"
                  [name]="inputField.key"
                  [required]="inputField.required ?? false"
                  #inputRef="ngModel"
                />
                <ng-container
                  *ngIf="integrationSettings.userInput[inputField.key]"
                >
                  <img
                    *ngIf="
                      isURL(
                        integrationSettings.userInput[inputField.key]
                          | colonToEmoji
                      )
                    "
                    [src]="
                      integrationSettings.userInput[inputField.key]
                        | colonToEmoji
                    "
                    alt="Emoji"
                    class="emoji-image"
                  />
                  <span
                    *ngIf="
                      !isURL(
                        integrationSettings.userInput[inputField.key]
                          | colonToEmoji
                      )
                    "
                    class="action-icon"
                    >{{
                      integrationSettings.userInput[inputField.key]
                        | colonToEmoji
                    }}</span
                  >
                </ng-container>
                <ng-container
                  *ngIf="!integrationSettings.userInput[inputField.key]"
                >
                  <span>
                    {{ inputField.default || "Select Emoji" }}
                  </span>
                </ng-container>
                <button
                  *ngIf="integrationSettings.userInput[inputField.key]"
                  (click)="
                    integrationSettings.userInput[inputField.key] = undefined;
                    $event.stopPropagation()
                  "
                  class="clear-button"
                >
                  <ion-icon name="close-outline"></ion-icon>
                </button>
              </div>
            </ion-item>

            <!-- Field Mapping Type -->
            <ion-item *ngIf="inputField.type === 'fieldMapping'">
              <div style="width: 100%; padding-right: 4px">
                <ion-label position="stacked" text-wrap>
                  {{ inputField.label }}
                  <span *ngIf="inputField.required" style="color: red">*</span>
                </ion-label>

                <ion-text color="warning">
                  <p style="margin-top: 7px; font-size: 0.7rem">
                    Please note: User and user group custom field mappings are
                    not currently supported.
                  </p>
                </ion-text>
                <!-- Existing mappings -->
                <div style="margin-top: 10px">
                  <div
                    *ngFor="
                      let mapping of integrationSettings.userInput[
                        inputField.key
                      ];
                      let i = index
                    "
                    class="flexed-align-center"
                    style="gap: 10px; margin-bottom: 10px"
                  >
                    <!-- External field input -->
                    <div style="flex: 1; min-width: 0">
                      <ion-label
                        position="stacked"
                        style="font-size: 0.7rem; margin-bottom: 4px"
                      >
                        {{ inputField.fieldMappingConfig.externalFieldLabel }}
                      </ion-label>
                      <ion-input
                        [value]="mapping.externalField || 'Select field...'"
                        readonly
                        (click)="
                          openExternalFieldPopover($event, inputField, i)
                        "
                        fill="outline"
                        style="cursor: pointer"
                      ></ion-input>
                    </div>

                    <!-- Internal field selector -->
                    <div style="flex: 1; min-width: 0">
                      <ion-label
                        position="stacked"
                        style="font-size: 0.7rem; margin-bottom: 4px"
                      >
                        {{ inputField.fieldMappingConfig.internalFieldLabel }}
                      </ion-label>
                      <ion-input
                        [value]="
                          mapping.internalFieldLabel || 'Select field...'
                        "
                        readonly
                        (click)="
                          openInternalFieldPopover($event, inputField, i)
                        "
                        fill="outline"
                        style="cursor: pointer"
                      ></ion-input>
                    </div>

                    <!-- Remove button -->
                    <ion-button
                      fill="clear"
                      color="danger"
                      (click)="removeFieldMapping(inputField, i)"
                      style="
                        --padding-start: 8px;
                        --padding-end: 8px;
                        margin-top: 20px;
                      "
                    >
                      <ion-icon name="trash-outline"></ion-icon>
                    </ion-button>
                  </div>

                  <!-- Add mapping button -->
                  <ion-button
                    fill="clear"
                    color="dark"
                    (click)="addFieldMapping(inputField)"
                    style="width: 100%; margin-top: 10px"
                    class="button-dark-border"
                  >
                    <ion-icon name="add" slot="start"></ion-icon>
                    Add Field Mapping
                  </ion-button>

                  <!-- Validation error -->
                  <ion-text
                    color="danger"
                    *ngIf="validationErrors[inputField.key] && formSubmitted"
                  >
                    <p style="margin: 5px 0; font-size: 0.7rem">
                      Please ensure all mappings are complete and have unique
                      Salesforce field names.
                    </p>
                  </ion-text>

                  <!-- Required field validation -->
                  <ion-text
                    color="danger"
                    *ngIf="
                      inputField.required &&
                      integrationForm.submitted &&
                      !integrationSettings.userInput[inputField.key]
                    "
                  >
                    <p style="margin: 5px 0; font-size: 0.7rem">
                      This field is required.
                    </p>
                  </ion-text>
                </div>
              </div>
            </ion-item>
            <!--End field mapping type-->
          </ion-list>
          <div *ngIf="shouldShowHelper(inputField)" class="admin-bar">
            {{ inputField.helper }}
          </div>
        </ion-card>
      </ng-container>
      <ion-button
        type="submit"
        [strong]="true"
        style="margin: 5px 10px"
        [disabled]="isSavingIntegration"
      >
        <span [hidden]="isSavingIntegration">Confirm</span>
        <ion-spinner
          name="crescent"
          [hidden]="!isSavingIntegration"
        ></ion-spinner>
      </ion-button>
    </div>
  </form>
</ion-content>
